<template>
	<b-card no-body>
		<template v-slot:header>
			<b-row>
				<b-col><h4>{{title}}</h4></b-col>
				<b-col class="text-right">
					<b-button variant="link" @click="localVisible = !localVisible" :class="!localVisible ? 'collapsed' : null"
								aria-controls="contentPanel"
								:aria-expanded="localVisible ? 'true' : 'false'">
						<icon :name="localVisible ? 'chevron-down':'chevron-left'"></icon>
					</b-button>
				</b-col>
			</b-row>
		</template>
		<b-card-body class="p-0">
			<b-collapse id="contentPanel" v-model="localVisible">
				<slot></slot>
			</b-collapse> 
		</b-card-body>
	</b-card>
</template>
<script>

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    localVisible: this.visible
  }),
  mounted () {
    this.localVisible = this.visible
  }
}
</script>



// WEBPACK FOOTER //
// CollapsibleCard.vue?ea838824